export enum RegistrationLegalPersonTypeEnum {
    NATIONAL_SIMPLE = 'Simples Nacional',
    NORMAL_REGIME = 'Regine Normal',
    NATIONAL_SIMPLE_EXCESS_SUB_LIMIT_OF_GROSS_REVENUE = 'Simples nacional, exceto sublimite de receita bruta'
}

export type RegistrationLegalPersonType = 'NATIONAL_SIMPLE' | 'NORMAL_REGIME' | 'NATIONAL_SIMPLE_EXCESS_SUB_LIMIT_OF_GROSS_REVENUE';
